import { CONFIG } from "../../config";
import {
  IEmailPreviewResult,
  IEmailTemplateDetail,
  IEmailTemplateSummary,
  IPreviewEmailPayload,
  IPublishEmailPayload,
  ISaveEmailDraftPayload,
  ITranslateEmailPayload,
} from "../../interfaces/emailTemplate.interface";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";

const BASE_PATH = `${CONFIG.API_SERVER.BASE_URL}/emails/v1/templates`;

export async function getEmailTemplatesServer() {
  const axios = await getTokenizedAxios();
  return axios
    .get<IEmailTemplateSummary[]>(BASE_PATH)
    .then((data) => data.data);
}

export async function getEmailTemplateServer(slug: string) {
  const axios = await getTokenizedAxios();
  return axios
    .get<IEmailTemplateDetail>(`${BASE_PATH}/${slug}`)
    .then((data) => data.data);
}

export async function saveEmailDraftServer(params: {
  slug: string;
  payload: ISaveEmailDraftPayload;
}) {
  const axios = await getTokenizedAxios();
  return axios
    .put<IEmailTemplateDetail>(`${BASE_PATH}/${params.slug}`, params.payload)
    .then((data) => data.data);
}

export async function publishEmailTemplateServer(params: {
  slug: string;
  payload: IPublishEmailPayload;
}) {
  const axios = await getTokenizedAxios();
  return axios
    .post<{ version: number }>(
      `${BASE_PATH}/${params.slug}/publish`,
      params.payload
    )
    .then((data) => data.data);
}

export async function translateEmailTemplateServer(params: {
  slug: string;
  payload: ITranslateEmailPayload;
}) {
  const axios = await getTokenizedAxios();
  return axios
    .post<IEmailTemplateDetail>(
      `${BASE_PATH}/${params.slug}/translate`,
      params.payload
    )
    .then((data) => data.data);
}

export async function previewEmailTemplateServer(params: {
  slug: string;
  payload: IPreviewEmailPayload;
}) {
  const axios = await getTokenizedAxios();
  return axios
    .post<IEmailPreviewResult>(
      `${BASE_PATH}/${params.slug}/preview`,
      params.payload
    )
    .then((data) => data.data);
}
